import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthRoutes } from './auth-routes';
import { LogService } from '@app/core/services/log.service';
import { Environment } from '@env/environment';
import { AuthService } from '@app/core/services/auth.service';

@Component({
	template: '',
})
export class AuthComponent implements OnInit {
	constructor(
		private readonly environment: Environment,
		private readonly authService: AuthService,
		private readonly router: Router,
		private readonly route: ActivatedRoute,
		private readonly location: Location,
		private readonly log: LogService
	) {}

	ngOnInit() {
		const routePath = this.route.snapshot.url[0].path;

		this.log.logInformation('ngOnInit', { route: routePath });
		switch (routePath) {
			case AuthRoutes.Logout:
				this.authService.logout();

				break;

			default:
				this.router.navigate([AuthRoutes.Landing]);
				break;
		}
	}
}
